export default "__VITE_ASSET__BldPM3i5__"